export default "__VITE_ASSET__BSwe5Hhd__"